module.exports = __webpack_public_path__ + "static/media/loading.8d5514bd.svg";